import type { EventOccurrenceViewModel, FunctionViewModel, TaskViewModel } from '@trinnvis/dabih-api-client';
import { LocalDate } from '../../../utilities/local-date';
import type { StartTaskInstance } from './start-task-instance';
import { RecurrenceRule } from '../../recurrence-rule/recurrence-rule';

export function getStartTaskInstances(
  organizationId: number | null,
  tasks: TaskViewModel[],
  singleUser: boolean,
  functionByUuid: Map<string, FunctionViewModel>,
  employeeUuid: string | undefined,
  employeeNameByUuid: Map<string, string>,
  eventOccurrenceByTaskUuid: Map<string, EventOccurrenceViewModel>,
  startAsMondayThisWeek: LocalDate,
) {
  const t: StartTaskInstance[] = [];
  tasks.forEach((task) => {
    let time: LocalDate | undefined = undefined;
    let weeksFromNow = -1;
    let executed = false;
    let add = false;
    if (task.locked && task.rrule && RecurrenceRule.hasStartDate(task.rrule)) {
      const relatedEvent = eventOccurrenceByTaskUuid.get(task.uuid);
      if (relatedEvent) {
        time = LocalDate.fromString(relatedEvent.date);
      } else {
        const rrule = RecurrenceRule.fromString(task.rrule);
        time = rrule.startDate();
      }
      const daysFromNow = startAsMondayThisWeek.until(time);
      if (daysFromNow === 0) {
        weeksFromNow = 0;
      } else {
        weeksFromNow = daysFromNow / 7;
      }
      add = true;
    } else if (task.lastExecuted) {
      time = LocalDate.fromString(task.lastExecuted);
      executed = true;
      add = true;
    }
    if (add) {
      const functionForTask = functionByUuid.get(task.functionUuid);
      if (functionForTask && time !== undefined) {
        let functionName = '';
        let employeeName = '';
        if (!singleUser) {
          functionName = functionForTask.name ?? '';
          if (functionForTask.employees.length > 0) {
            const uuid = functionForTask.employees[0];
            const name = employeeNameByUuid.get(uuid);
            if (name !== undefined) {
              employeeName = name;
            }
          }
        }
        const functionPage = functionForTask.pages[0];
        let myTask = false;
        if (functionForTask.employees[0] === employeeUuid) {
          myTask = true;
        }
        const timeDisplay = 'Uke ' + ('00' + time.weekOfYear()).slice(-2) + ' ' + time.year();
        const href =
          '/account/' + organizationId + '/' + functionPage + '/functions/' + task.functionUuid + '/tasks/' + task.uuid;
        t.push({
          uuid: task.uuid,
          name: task.name !== undefined ? task.name : '',
          time: time,
          weeksFromNow: weeksFromNow,
          timeDisplay: timeDisplay,
          executed: executed,
          functionName: functionName,
          employeeName: employeeName,
          myTask: myTask,
          href: href,
          helpContent: task.helpContent ?? '',
          procedures: task.procedures ?? '',
        });
      }
    }
  });
  t.sort((a: StartTaskInstance, b: StartTaskInstance) => a.time.asInteger() - b.time.asInteger());
  return t;
}
